import React, { useState } from 'react';
import { WppTypography, WppCard, WppButton } from '@wppopen/components-library-react';
import { useNavigate } from 'react-router-dom';
import { SideModal } from 'components';
import { projectionSlice } from 'Redux/projectionsSlice';
import USAFlag from '../../../assets/USAFlag.svg?react';
import UKFlag from '../../../assets/UKFlag.svg?react';
import { Localization, routerFormat } from 'utils';
import styles from '../StartPage.module.scss';
import { CardSize } from '@wppopen/components-library';
import { useSelector } from 'react-redux';

const {
    MainContentCompliance,
    MainContentGridCard,
    MainContentGridCardWrapper,
    MainContentGridCardHeader,
    MainContentGridCardHeaderText,
} = styles;

interface LocalizationCardProps {
    localization: Localization;
    title: string;
    ages: string;
    description: string;
    compliance: string;
    isDisabled?: boolean;
    size: CardSize;
}

const flagsSchema: Record<Localization, any> = {
    [Localization.US]: {
        flag: <USAFlag width={24} height={24} />,
    },
    [Localization.UK]: {
        flag: <UKFlag width={24} height={24} />,
    },
};

export const LocalizationCard = ({
    localization,
    title,
    ages,
    description,
    compliance,
    size,
    isDisabled = false,
}: LocalizationCardProps) => {
    const [isModalShown, setIsModalShown] = useState(false);
    const {
        [localization]: { currentTab },
    } = useSelector(projectionSlice);
    const navigate = useNavigate();

    const handleLocalization = (loc: Localization) => {
        navigate(`/${loc}/projections/${routerFormat(currentTab.title as string, true)}`);
    };

    return (
        <>
            <WppCard
                className={MainContentGridCard}
                size={size}
                data-testid={`OVERVIEW.${localization.toUpperCase()}.CONTAINER.CARD`}
            >
                <div className={MainContentGridCardWrapper}>
                    <div>
                        <div className={MainContentGridCardHeader}>
                            {flagsSchema[localization]['flag']}
                            <div className={MainContentGridCardHeaderText}>
                                <WppTypography type="xl-heading">{title}</WppTypography>
                                <WppTypography type="s-strong">{ages}</WppTypography>
                            </div>
                        </div>
                        <WppTypography
                            type="m-body"
                            data-testid={`OVERVIEW.${localization.toUpperCase()}.CONTAINER.CARD.DESCRIPTION`}
                        >
                            {description}
                        </WppTypography>
                    </div>
                    <WppButton
                        style={{ marginLeft: 'auto' }}
                        variant="primary"
                        data-testid={`OVERVIEW.${localization.toUpperCase()}.BUTTON.EXPLORE`}
                        onClick={() => handleLocalization(localization)}
                        disabled={isDisabled}
                    >
                        Explore
                    </WppButton>
                    <WppTypography
                        className={MainContentCompliance}
                        type="xs-body"
                        data-testid={`OVERVIEW.${localization.toUpperCase()}.LICENSE.COMPLIANCE`}
                        onClick={() => setIsModalShown(true)}
                    >
                        {compliance}
                    </WppTypography>
                </div>
            </WppCard>
            <SideModal
                isSidebarShown={isModalShown}
                setIsSidebarShown={setIsModalShown}
                title="Compliance"
                localization={localization}
            />
        </>
    );
};
